import useResource from "hooks/resources"

export function useAttributeCategories(instrument) {
  return useResource({
    resource: "attributeCategories",
    url: () => {
      if (!instrument.id) {
        return null
      }
      return {
        id: `attributeCategories-${instrument.id}`,
        query: `query ($portfolioId: String!) {
          portfolio(id: $portfolioId) {
            positionAttributeCategories {
              id
              name
            }
          }
        }`,
        variables: { portfolioId: instrument.id },
      }
    },
  }, ["portfolio", "positionAttributeCategories"])
}
